import React from 'react'
import { Card, Tabs } from 'antd';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import Users from './users';
import WaitList from './WaitList';
import Incompleted from './Incompleted';


const User = () => {

  const menus =
  {
    users: <Users />,
    waitlist: <WaitList />,
    incompleted: <Incompleted />,
  }
  return (
    <>
      <Card className="mt-5">
        <Tabs
          className="p-0 m-0"
          defaultActiveKey="1"
          size="middle"
          type="card"
          items={CONSTANTS.TAB_MENU.USER_TABS.map((ele) => {
            return {
              label: `${ele.Label}`,
              key: `${ele.id}`,
              children: menus[ele.id],
            };
          })}
        />
      </Card>

    </>
  )
}

export default User